export const Grid = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="5" y="5" width="8" height="8" rx="1" stroke="currentColor" stroke-width="2"/>
<rect x="19" y="5" width="8" height="8" rx="1" stroke="currentColor" stroke-width="2"/>
<rect x="5" y="19" width="8" height="8" rx="1" stroke="currentColor" stroke-width="2"/>
<rect x="19" y="19" width="8" height="8" rx="1" stroke="currentColor" stroke-width="2"/>
</svg>`;
